module.exports = __webpack_public_path__ + "img/IMG_20180714_163920.4754f711.jpg";